<template>
    <div>
        <div class="row">
            <div class="col-12 col-md-6 my-2">
                <label for="provinces">
                    {{ $t('label.province') }}
                    <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                        <span class="tooltip-text">استان و شهر انتخاب شده باید مطابق با کدپستی انتخاب شده باشد.</span>
                        <i class="fa fa-info-circle"></i>
                    </span>
                </label>
                <select
                    id="provinces"
                    name="provinces"
                    v-model="form_data.province_code"
                    class="form-control kt-selectpicker"
                >
                    <option
                        v-bind:key="province.id"
                        v-for="province in provinceCodes"
                        :selected="form_data.province_code == province.province_code"
                        :value="province.province_code"
                    >
                        <span>{{ province.name }}</span>
                    </option>
                </select>

            </div>
            <div class="col-12 col-md-6 my-2">
                <label for="cities">
                    {{ $t('label.city') }}
                    <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                        <span class="tooltip-text">استان و شهر انتخاب شده باید مطابق با کدپستی انتخاب شده باشد.</span>
                        <i class="fa fa-info-circle"></i>
                    </span>
                </label>
                <select
                    id="cities"
                    name="cities"
                    v-model="form_data.city_code"
                    class="form-control"
                >
                    <option
                        v-bind:key="city.city_code"
                        v-for="city in getProvinceCities"
                        :selected="form_data.city_code == city.city_code"
                        :value="city.city_code"
                    >
                        <span>{{ city.name }}</span>
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 my-2">
                <label for="address">
                    {{ $t("label.address") }}
                    <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                        <span class="tooltip-text">جهت ثبت درگاه پرداخت‌یاری کد پستی وارد کنید که در سامانه مالیات وارد کرده اید</span>
                        <i class="fa fa-info-circle"></i>
                    </span>
                </label>
                <select
                        v-if="addresses"
                        id="address"
                        name="address"
                        v-model="form_data.address"
                        class="form-control kt-selectpicker"
                >
                    <option
                            v-bind:key="address.id"
                            v-for="address in addresses"
                            :value="address.id"
                    >
                        {{ address.address }}
                    </option>
                </select>
                <small v-if="next_btn_in_third_step_clicked && !validation_errors.address" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
            </div>
            <div class="col-12 col-md-6 my-2">
                <label for="phone_number">
                    {{$t('label.phone_number') }}
                    <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                        <span class="tooltip-text">شماره همراه باید به نام پذیرنده باشد.</span>
                        <i class="fa fa-info-circle"></i>
                    </span>
                </label>
                <input
                        dir="ltr"
                        id="phone_number"
                        class="form-control"
                        name="phone_number"
                        v-model="form_data.phone_number"
                />
                <small v-if="next_btn_in_third_step_clicked && !validation_errors.phone_number" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
            </div>
            <div class="col-12 col-md-6 my-2" v-if="current_user.user_type == user_types.LEGAL ? false : true">
                <label for="birth_crtfct_number">
                    {{ $t("label.birth_crtfct_number")  }}
                </label>
                <input
                        dir="ltr"
                        id="birth_crtfct_number"
                        class="form-control"
                        name="birth_crtfct_number"
                        v-model="form_data.birth_crtfct_number"
                />
                <small v-if="next_btn_in_third_step_clicked && !validation_errors.birth_crtfct_number" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
            </div>
            <div class="col-12 col-md-6 my-2">
                <label for="telephone">
                    {{ $t("label.telephone") }}
                </label>
                <input
                        dir="ltr"
                        id="telephone"
                        class="form-control"
                        name="telephone"
                        @keyup="check"
                        v-model="form_data.telephone"
                />
                <small v-if="next_btn_in_third_step_clicked && !validation_errors.telephone" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
            </div>

            <div class="col-sm my-2">
              <div class="form-group my-0">
                <label for="telephone">
                  {{ $t("label.user_server_ip") }}
                </label>
                <div v-for="(ip, key) in ips" :key="key" class="mb-2">
                  <input
                      type="text"
                      dir="ltr"
                      :class="['form-control', next_btn_in_third_step_clicked && ip && !isValidIp(ip) ? 'is-invalid' : '']"
                      :id="'ip_title' + key"
                      :name="'ip_title' + key"
                      v-model="ips[key]"
                  />
                  <small v-if="next_btn_in_third_step_clicked && ip && !isValidIp(ip)" class="text-danger px-2">فرمت آی‌پی معتبر نیست.</small>
                </div>
                <small v-if="next_btn_in_third_step_clicked && !validation_errors.ips" class="text-danger px-2">حداقل یک آی‌پی باید وارد شود.</small>
              </div>
            </div>
            <div class="col-12 my-2">
              <button class="btn btn-danger mr-2 px-2 text-center"
                      type="button"
                      @click="removeIp()"
                      :disabled="ips.length <= 1"
              >
                <i class="text-center px-2 fas fa-minus"></i>
              </button>
              <button class="btn btn-primary mx-auto px-2 text-center"
                      type="button"
                      @click="addIp()"
                      :disabled="cannotAddMoreIps"
              >
                <i class="text-center mx-auto px-2 fas fa-plus"></i>
              </button>
            </div>
            <p class="font-weight-bold">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#F19E39"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
              <span>
                حداکثر تعداد آی پی مجاز {{ips_max_count}} عدد است.
                </span>
            </p>
        
        </div>

        <div class="d-flex align-items-center px-3 mt-4">
            <div>
                <button
                        type="button"
                        @click="step_back()"
                        class="btn btn-success px-4"
                        style="border-radius: 10px"
                >
                    <span>مرحله قبل</span>
                </button>
            </div>
            <div class="mr-auto">
              <button
                  type="button"
                  @click="next_step()"
                  class="btn btn-success px-4"
                  style="border-radius: 10px"
              >
                <span>مرحله بعد</span>
              </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {subcategories} from "@/constants/subcategories";
    import {mapGetters} from "vuex";
    import {userTypes} from '@/constants/userTypes';
    import {birthCrtfctSeriesLetters} from '@/constants/birthCrtfctSeriesLetter'
    import { province_codes, provinceCities } from '@/constants/cityAndProvinceCodes';

    export default {
        props: {
            wizard: Object,
            form_data: Object,
            ips: {
              type: Array,
              default: () => [""]
            },
        },
        computed: {
            ...mapGetters("shebaNumber", ["sheba_numbers"]),
            ...mapGetters("address", ["addresses"]),
            ...mapGetters('user', [
                'current_user',
            ]),
            getProvinceCities() {
                return provinceCities(this.form_data.province_code)
            },
            cannotAddMoreIps() {
              return this.ips.length >= this.ips_max_count;
            },
        },
        data() {
            return {
                user_types: userTypes,
                subcategories: subcategories,
                provinceCodes: province_codes,
                birthCrtfctSeriesLetters: birthCrtfctSeriesLetters,
                etrust_certificate_types: [
                    {
                        key: 1,
                        value: this.$t('etrust_certificate_types.one')
                    },
                    {
                        key: 2,
                        value: this.$t('etrust_certificate_types.two')
                    },
                    {
                        key: 0,
                        value: this.$t('etrust_certificate_types.other')
                    },
                ],
                validation_errors: {},
                next_btn_in_third_step_clicked: false,
                ips_max_count: 3,
            };
        },
        watch: {
          validation_errors() {
            this.next_btn_in_third_step_clicked = false;
          },
        },
        methods: {
            check(event) {
                const persianCharacters = /[۰-۹]/;
                if (persianCharacters.test(event.key)) {
                    window.alert('لطفا کیبورد خود را به انگلیسی تغییر دهید');
                }
            },
            step_back() {
                this.wizard.current_step = 2;
                this.validation_errors = {}
            },
            isValidIp(ip) {
              return /^(25[0-5]|2[0-4]\d|[01]?\d\d?)(\.(25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/.test(ip.trim());
            },
            step_is_valid() {
              this.validation_errors.address = !!this.form_data.address;
              this.validation_errors.telephone = !!this.form_data.telephone;
              this.validation_errors.birth_crtfct_number = this.current_user.user_type == this.user_types.REAL ? !!this.form_data.birth_crtfct_number : true;
              this.validation_errors.phone_number = !!this.form_data.phone_number;
              const nonEmptyIps = this.ips.filter(ip => ip && ip.trim() !== '');
              this.validation_errors.ips = nonEmptyIps.length > 0;
              this.validation_errors.ip_format = nonEmptyIps.length > 0 && nonEmptyIps.every(ip => this.isValidIp(ip));

              return this.validation_errors.address
                  && this.validation_errors.telephone
                  && this.validation_errors.birth_crtfct_number
                  && this.validation_errors.phone_number
                  && this.validation_errors.ips
                  && this.validation_errors.ip_format
            },
            next_step() {
              this.next_btn_in_third_step_clicked = true;

              if (this.step_is_valid()) {
                this.validation_errors = {};
                this.form_data.ips = this.ips;
                this.wizard.current_step = 4
              }
            },
            addIp() {
              if (this.ips.length >= this.ips_max_count) {
                return;
              }

              this.ips.push('');
            },
            removeIp() {
              if (this.ips.length === 1) {
                return;
              }

              this.ips.pop();
            },
        },
    };
</script>

<style scoped>

.mt-alert {
    margin: 1.8rem 0;
}
</style>

<style>
@media (max-width: 576px) {
  .bootstrap-select .dropdown-menu.show {
    left: 0 !important;
    right: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
    transform: translateY(36px) !important;
  }

  .bootstrap-select .dropdown-menu .dropdown-item {
    white-space: normal !important;
    word-break: break-word;
  }
}
</style>